import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { EMPTY, firstValueFrom, Observable, of, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { Md5 } from 'ts-md5';
import { jwtDecode, JwtPayload } from "jwt-decode";
import { catchError, finalize, map, switchMap, tap } from 'rxjs/operators';
import { ArticuloService } from './articulo.service';
import { Usuario, UsuarioBloqueo, jsonMapReplacer, UsuarioErrorAuth, UsuarioAuth } from '../models/usuario.model';
import { PedidoService } from './pedido.service';
import { AuthService } from '../services/auth.service';
import { StorageService } from './storage.service';
import { env } from 'node:process';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  private SERVER_URL = environment.SERVER_USU_URL;
  private SERVER_ADM_URL = environment.SERVER_ADM_URL;
  private SERVER_HUB_URL = environment.SERVER_HUB_URL;
  // SERVER_AUTH deprecated - se usa Bearer token desde localStorage
  public usuarios: Usuario[];
  public usuario: Usuario | undefined;
  public usuarioBloqueo: UsuarioBloqueo | undefined;
  public usrSelect: number = 0;
  public usuarioErrorAuth: UsuarioErrorAuth | undefined;
  public usuarioAuth: UsuarioAuth | undefined;
  public usuarioSeleccion: number = 0;
  public users: Usuario[] = [];
  public contLogin: number = 0;
  constructor(
    private http: HttpClient,
    public router: Router,
    private authService: AuthService,
    private articuloService: ArticuloService,
    private pedidoService: PedidoService,
    private storageService: StorageService
  ) {
    this.pedidoService.totalizaObservable$.subscribe((accion: string) => {
      if (this.usuario != undefined && accion === 'consulta') {
        const usuarioResp$ = this.consultaUsuarioWeb(this.usuario.usuw_id);
        usuarioResp$.subscribe(
          res => {
            this.authService.usuarios = res;
            this.storageService.setItem('usuarios_model', JSON.stringify(this.authService.usuarios, jsonMapReplacer));
          },
          err => console.log(err),
          () => console.log('ACTUALIZA LISTA CLIENTES- HTTP request completed.')
        );
      }
    });
    this.authService.usuario = this.storageService.getItem("usuario_model") != null ? JSON.parse(this.storageService.getItem("usuario_model")!) : null;
    this.authService.usuarios = this.storageService.getItem("usuarios_model") != null ? JSON.parse(this.storageService.getItem("usuarios_model")!) : null;
    this.usuario = this.authService.usuario;
    this.usuarios = this.authService.usuarios;
    if (this.authService.usuario != undefined && this.storageService.getItem("usuarios_model") != null && JSON.parse(this.storageService.getItem("usuarios_model")!) != null) {
      this.usrSelect = this.authService.usuarios.findIndex(usr => usr.cli_id === this.authService.usuario!.cli_id) ?? 0;
      this.userAsign(this.usrSelect);
    }


    // this.logout();
    return;
    /*
    if (this.authService.isLoggedIn() && this.authService.usuario === undefined && localStorage.getItem('usuario_model') !== null) {
      this.authService.usuario = JSON.parse(localStorage.getItem('usuario_model'));
      this.pedidoService.inicializaParametrosUsu();
    } else if (environment.VER_PROD_LOGOUT) {
      // consultar almacen
      this.parametro('alm_id')
        .subscribe(
          (res: any) => {
            localStorage.setItem('alm_id', res.valor);
          },
          err => handleError(err),
          () => console.log('ARTICULOS- HTTP request completed.')
        );

    } else {
      localStorage.removeItem('usuario_model');
      localStorage.removeItem('ACCESS_TOKEN');
    }*/
  }

  public loginError = false;
  public loginBloqueoIntentos = false;
  public loginBloqueoPin = false;
  public loginBloqueoCaducidad = false;
  public loginBloqueoNuevaClave = false;
  public loginBloqueoNuevaClaveOk = false;
  public loginBloqueoNuevaClaveMensaje = '';
  public loginOlvidoClave = false;
  public loginOlvidoClaveSolicitadoOk = false;
  public loginOlvidoClaveTexto = '';
  public loginCambioClave = false;
  public numElementosListUsr = 0;
  public passAntiguaTrue = false;
  // el usuario pide cambio de clave desde
  public loginCambiarClave = false; // si accede desde Cambiar contraseña (True) / si accede desde clave caducada o olvido de clave (False)
  public onLogin = false;
  public urlUserNameGmAuth: string = this.SERVER_ADM_URL + '/users/login';
  private validaToken: any;

  login(empresa: string, usuario: string, clave: string, recordar: boolean): void {
    const claveHash = Md5.hashStr(clave);
    if (environment.AUTH_TOKEN) {
      // this.validaUsuarioToken(empresa, usuario, claveHash.toString(), recordar);
      // this.validaUsuarioPhp(empresa, usuario, clave, recordar);
      // this.http.post(this.urlUserNameGmAuth, usuario).subscribe();
      this.validaUsuarioGmAuth(empresa, usuario, clave, recordar);

    } else {
      this.validaUsuarioBasis(empresa, usuario, clave, recordar);
    }
  }

  userAsign(usr: number) {
    this.users = this.authService.usuarios;
    this.usrSelect = usr;
    this.numElementosListUsr = this.authService.usuarios.length;
    this.authService.usuario = this.CambiaUsuario(this.usrSelect, this.users);//JSON.parse(localStorage.getItem("usuario_model"));
    this.usuario = this.authService.usuario;
  }
  compruebaUsuarioToken(empresa: string, usuario: string, clave: string) {
    const url = this.SERVER_URL + '/usuario';
    return this.http.post<any>(url,
      {
        empresa,
        usuario,
        clave
      },
      {
        headers: new HttpHeaders().set('Authorization',
          (this.storageService.getItem('ACCESS_TOKEN') !== null) ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''),
      });
  }

  validaUsuarioToken(empresa: string, usuario: string, clave: string, recordar: boolean): void {
    const url = this.SERVER_URL + '/usuario';
    this.loginBloqueoCaducidad = false;
    this.loginBloqueoIntentos = false;
    this.loginBloqueoPin = false;
    this.loginError = false;

    this.authService.getAccessToken()
      .then((accessToken: string) => {
        this.validaToken = accessToken;
        console.log('valida usuario: ' + url + ', TOKEN=' + 'Bearer ' + accessToken);

        this.http.post<any>(url,
          { empresa, usuario, clave },
          {
            headers: new HttpHeaders().set('Authorization', 'Bearer ' + accessToken)
          }
        ).subscribe({
          next: (res: any) => {
            if (res.resultado.length > 0) {
              this.usuarioBloqueo = res.resultado[0];

              if (this.usuarioBloqueo != undefined && this.usuarioBloqueo.hasOwnProperty('intentos_login')) {
                if (this.usuarioBloqueo.usu_estado === 'I' || this.usuarioBloqueo.usu_estado === 'K') {
                  this.loginBloqueoIntentos = this.usuarioBloqueo.usu_estado === 'I';
                  this.loginBloqueoPin = this.usuarioBloqueo.usu_estado === 'K';

                  this.logout();
                  if (this.router.url !== '/login') {
                    this.router.navigate(['']).then();
                  }
                  return;
                } else {
                  this.loginError = true;
                  this.logout();
                  if (this.router.url !== '/login') {
                    this.router.navigate(['login']).then();
                  }
                  return;
                }
              }

              // Login correcto
              this.usuario = res.resultado[0];
              this.authService.usuarios = res.resultado;

              if (this.usuario != undefined && this.usuario.clave_caducada === 0) {
                this.loginBloqueoCaducidad = true;
              } else if (this.usuario != undefined && this.usuario.usu_estado === 'K') {
                this.loginBloqueoNuevaClave = true;
              } else if (this.usuario != undefined) {
                this.procesaUsuarioObservable(this.usuario, recordar);
                this.authService.logToken();
              }
            } else {
              this.loginError = true;
              this.logout();
              if (this.router.url !== '/') {
                this.router.navigate(['']).then();
              }
            }
          },
          error: (err) => {
            this.loginError = true;
            this.logout();
            if (this.router.url !== '/') {
              this.router.navigate(['']).then();
            }
          },
          complete: () => { }
        });
      });
    // return this.http.get<any>(url + '?empresa=&usuario=javier.jimenez@asg-si.com&clave=asg', httpOptions);

    /*
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        //Authorization: 'Bearer ' + token
      }),
      body: {
        empresa: '',
        usuario,
        clave
      }
    };    {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //Authorization: 'Bearer ' + token
      }, )
    */
  }


  validaUsuarioBasis(empresa: string, usuario: string, clave: string, recordar: boolean): void {
    const url = this.SERVER_URL + '/usuario';

    // Limpiar estados de login
    this.loginBloqueoCaducidad = false;
    this.loginBloqueoIntentos = false;
    this.loginBloqueoPin = false;
    this.loginError = false;

    this.http.post<any>(url,
      { empresa, usuario, clave },
      {
        // SERVER_AUTH deprecated - no se requiere autenticación para este endpoint
      }
    ).subscribe({
      next: (res: any) => {
        if (res.resultado.length > 0) {
          this.usuarioBloqueo = res.resultado[0];

          if (this.usuarioBloqueo != undefined && this.usuarioBloqueo.hasOwnProperty('intentos_login')) {
            if (this.usuarioBloqueo.usu_estado === 'I' || this.usuarioBloqueo.usu_estado === 'K') {
              this.loginBloqueoIntentos = this.usuarioBloqueo.usu_estado === 'I';
              this.loginBloqueoPin = this.usuarioBloqueo.usu_estado === 'K';

              this.logout();
              if (this.router.url !== '/login') {
                this.router.navigate(['']).then();
              }
              return;
            } else {
              this.loginError = true;
              this.logout();
              if (this.router.url !== '/login') {
                this.router.navigate(['login']).then();
              }
              return;
            }
          }

          // Login correcto
          this.usuario = res.resultado[0];
          if (this.usuario != undefined && this.usuario.clave_caducada === 0) {
            this.loginBloqueoCaducidad = true;
          } else if (this.usuario != undefined && this.usuario.usu_estado === 'K') {
            this.loginBloqueoNuevaClave = true;
          } else if (this.usuario != undefined) {
            this.storageService.setItem('ACCESS_TOKEN', new Date().getTime().toString());
            this.procesaUsuarioObservable(this.usuario, recordar);
            // this.authService.logToken();
          }

        } else {
          this.loginError = true;
          this.logout();
          if (this.router.url !== '/') {
            this.router.navigate(['']).then();
          }
        }
      },
      error: (err) => {
        this.loginError = true;
        this.logout();
        if (this.router.url !== '/') {
          this.router.navigate(['']).then();
        }
      },
      complete: () => { }
    });
  }


  instanceOfUsuarioErrorAuth(object: any): object is UsuarioErrorAuth {
    return 'error' in object;
  }
  instanceOfUsuarioAuth(object: any): object is UsuarioAuth {
    return 'access_token' in object;
  }
  validaUsuarioGmAuth(empresa: string, usuario: string, clave: string, recordar: boolean): void {
    // limpiar el login por defecto
    const url = environment.OAUTH_URL_GMAUTH + '/token';
    const ci = environment.CLIENT_ID;
    const cs = environment.CLIENT_SECRET;
    this.loginBloqueoCaducidad = false;
    this.loginBloqueoIntentos = false;
    this.loginBloqueoPin = false;
    this.loginError = false;
    this.onLogin = true;
    this.storageService.setItem('usuario', usuario);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');

    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('client_id', ci)
      .set('client_secret', cs)
      .set('username', usuario)
      .set('password', clave);

    const usuarioEnvia = {
      'username': usuario,
      'password': clave,
      'grant_type': 'password',
      'client_id': ci,
      'client_secret': cs
    };
    this.http.post<any>(url,
      body.toString(),
      {
        headers
      })
      .subscribe(
        (res: UsuarioAuth | UsuarioErrorAuth) => {
          this.onLogin = false;

          if (this.instanceOfUsuarioErrorAuth(res)) {
            this.usuarioErrorAuth = res;
            if (this.usuarioErrorAuth.hasOwnProperty('error')) {
              if (this.usuarioErrorAuth.error === 'invalid_grant' && this.usuarioErrorAuth.error_description == 'Account is not fully set up') {
                // Contraseña caducada
                this.router.navigate(['CambioClave']).then();
                this.loginBloqueoCaducidad = true;
              }
              this.loginError = true;
              this.logout();
              if (this.router.url !== '/login') {
                this.router.navigate(['login']).then();
              }
              return;
            }
          } else {
            // logeo correcto
            this.usuarioAuth = res;
            this.storageService.setItem('ACCESS_TOKEN', this.usuarioAuth.access_token);
            this.storageService.setItem('ACCESS_TOKEN_EXPIRE', this.usuarioAuth.expires_in.toString());
            this.storageService.setItem('REFRESH_TOKEN', this.usuarioAuth.refresh_token);
            this.storageService.setItem('REFRESH_TOKEN_EXPIRE', this.usuarioAuth.refresh_expires_in.toString());
            this.storageService.setItem('ACCESS_TOKEN_TYPE', this.usuarioAuth.token_type);
            this.storageService.setItem('ACCESS_TOKEN_DATE', Date.now().toString());
            this.contLogin = 0;
            // TODO: decodificar token
            // TODO: llamar a shop/usu/usuario para obtener datos de usuario
            const token: any = jwtDecode<JwtPayload>(this.usuarioAuth.access_token);
            this.consultaUsuariosWeb(token.usuw_id, recordar);
            // TODO: llamar a gmauth para obtener estado del password (un solo uso, etc)
            //
            // if (this.usuario.clave_caducada === 0) {
            //   this.loginBloqueoCaducidad = true;
            // } else if (this.usuario.usu_estado === 'K') {
            //   this.loginBloqueoNuevaClave = true;
            // } else {
            //   this.procesaUsuarioObservable(this.usuario, recordar);
            //   this.authService.logToken();
            // }
          }
        },
        err => {
          if (err.error.error === 'invalid_grant' && err.error.error_description == 'Account is not fully set up') {
            // Contraseña caducada
            this.router.navigate(['CambioClave']).then();
            this.loginBloqueoCaducidad = true;
          }
          else {
            this.onLogin = false;
            this.loginError = true;
            this.logout();
          }
        },
        () => { }
      );

  } // validaUsuarioGmAuth
  validaPwdAntigua(usuario: string, clave: string): void {
    // limpiar el login por defecto
    const url = environment.OAUTH_URL_GMAUTH + '/token';
    const ci = environment.CLIENT_ID;
    const cs = environment.CLIENT_SECRET;
    this.loginBloqueoCaducidad = false;
    this.loginBloqueoIntentos = false;
    this.loginBloqueoPin = false;
    this.loginError = false;
    this.onLogin = true;
    this.storageService.setItem('usuario', usuario);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');

    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('client_id', ci)
      .set('client_secret', cs)
      .set('username', usuario)
      .set('password', clave);

    const usuarioEnvia = {
      'username': usuario,
      'password': clave,
      'grant_type': 'password',
      'client_id': ci,
      'client_secret': cs
    };
    this.http.post<any>(url,
      body.toString(),
      {
        headers
      })
      .subscribe(
        (res: UsuarioAuth | UsuarioErrorAuth) => {
          this.onLogin = false;
          if (this.instanceOfUsuarioErrorAuth(res)) {
            this.usuarioErrorAuth = res;
            if (this.usuarioErrorAuth.hasOwnProperty('error')) {

              this.router.navigate(['']).then();
              this.loginError = true;
              this.logout();
              if (this.router.url !== '/login') {
                this.router.navigate(['login']).then();
              }
              return;
            }
          } else {
            this.passAntiguaTrue = true;
          }
        },
        err => {
          this.onLogin = false;
          this.loginError = true;
          this.logout();
          if (this.router.url !== '/') {
            this.router.navigate(['']).then();

          }
          this.passAntiguaTrue = false;
        },
        () => { }
      );

  } // validaUsuarioGmAuth

  consultaUsuariosWeb(usuw_id: number, recordar: boolean): void {
    console.log("VALORES: " + usuw_id + "  " + recordar);
    const usuarioResp$ = this.consultaUsuarioWeb(usuw_id);
    usuarioResp$.subscribe(
      res => {
        this.authService.usuarios = res;
        this.numElementosListUsr = this.authService.usuarios.length;
        this.usuario = this.selectUsuarioList(this.authService.usuarios, 0) != null ? this.selectUsuarioList(this.authService.usuarios, 0)! : undefined// usuarios[0]
        if (this.usuario != undefined)
          this.procesaUsuarioObservable(this.usuario, recordar);
      },
      err => console.log(err),
      () => console.log('ARTICULOS- HTTP request completed.')
    );
  }
  consultaUsuarioWeb(usuwId: number): Observable<any> {
    const headersToken = new HttpHeaders({
      'Content-Type': 'application/json',
      //Authorization: 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN')
      // //Authorization: this.SERVER_AUTH
    });
    const headersBasic = new HttpHeaders({
      'Content-Type': 'application/json',
      //Authorization: environment.SERVER_AUTH
      // //Authorization: this.SERVER_AUTH
    });
    const url = this.SERVER_URL + '/usuario';

    return this.http.get(url, {
      headers: (environment.AUTH_TOKEN) ? headersToken : headersBasic,
      params: {
        usuw_id: usuwId.toString()
      }
    });

  }

  public putUsuario(usuario: UsuarioBloqueo) {
    const url = this.SERVER_URL + '/usuario';
    // usuario.clave = Md5.hashStr(usuario.clave.toString());

    return this.http.put<any>(url,
      usuario,
      {
        headers: new HttpHeaders().set('Authorization',
          (this.storageService.getItem('ACCESS_TOKEN') !== null) ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : ''),
      });
    // return this.http.put<any>(url,
    //     usuario,
    //     {
    //       headers: new HttpHeaders().set('Authorization', environment.SERVER_AUTH),
    //     });
  }

  public putUsuarioPhp(usuario: UsuarioBloqueo) {
    const url = environment.OAUTH_URL_GMAUTH + '/clave';

    const usuarioEnvia = 'usuario=' + usuario.usuario
      + '&clave=' + usuario.clave + '&usuw_id=' + usuario.usuw_id + '&usu_estado=' + usuario.usu_estado;
    return this.http.post<any>(url,
      usuarioEnvia,
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          // //Authorization: environment.AUTH_TOKEN ? 'Bearer ' + localStorage.getItem('ACCESS_TOKEN') : this.SERVER_AUTH
        })
      });

  }


  // Seleccion de los clientes en el usuario
  selectUsuarioList(usuarios: Usuario[], usuarioSeleccion: number): Usuario | null {
    return usuarios.length > 0 ? usuarios[usuarioSeleccion] : null;
  }


  procesaUsuarioObservable(usuario: Usuario, recordar: boolean) {
    this.authService.usuario = usuario;
    usuario.imp_portes = 0;
    usuario.parametrosMap = new Map();
    if (usuario.parametros == null || usuario.parametros === '') {
      usuario.parametrosMap = this.parametrosMap();
    }
    if (usuario.parametros != null && usuario.parametros !== '') {
      // inicializa parametros con valores por defecto
      usuario.parametros.split(',').forEach((valor) => {
        const parametro = valor.split('=');
        usuario.parametrosMap.set(parametro[0], parametro[1]);
        if (parametro[0] === 'imp_ped_minimo') {
          usuario.pedido_minimo = parseInt(parametro[1], 10);
        } else if (parametro[0] === 'imp_ped_maximo') {
          usuario.pedido_maximo = parseInt(parametro[1], 10);
        } else if (parametro[0] === 'ped_min_portes') {
          usuario.ped_min_portes = parseFloat(parametro[1] === '' ? '0' : parametro[1]);
        } else if (parametro[0] === 'imp_portes') {
          usuario.imp_portes = parseFloat(parametro[1]);
        } else if (parametro[0] === 'dias_servicio') {
          usuario.dias_servicio = parseInt(parametro[1], 10);
        } else if (parametro[0] === 'precio_caja') {
          usuario.precio_caja = parametro[1] === 'S' ? true : false;
          environment.VER_PVP_CAJA = usuario.precio_caja;
        } else if (parametro[0] === 'impuestos') {
          usuario.impuestos = parametro[1] === 'C' ? true : false;
        } else if (parametro[0] === 'hora_corte') {
          usuario.hora_corte = parametro[1];
        } else if (parametro[0] === 'portes') {
          usuario.portes = parametro[1] === 'S' ? true : false;
          environment.PORTES = usuario.portes;
        } else if (parametro[0] === 'ver_fec_servicio') {
          usuario.fecha_servicio = parametro[1] === 'S' ? true : false;
          environment.FSERVICIO = usuario.fecha_servicio;
        } else if (parametro[0] === 'stock') {
          usuario.stock = parametro[1];
          environment.COMPRAR_SIN_STOCK = usuario.stock;
        } else if (parametro[0] === 'tbulto_ver') {
          usuario.tbulto_ver = parametro[1];
          environment.TIPO_BULTO = usuario.tbulto_ver;
        } else if (parametro[0] === 'tbulto_def') {
          usuario.tbulto_def = parametro[1];
          environment.TIPO_BULTO_DEF = usuario.tbulto_def;
        } else if (parametro[0] === 'permite_unid') {
          usuario.permite_unid = parametro[1];
          this.storageService.setItem('permite_unid', usuario.permite_unid);
        }

      });
    }
    if (usuario.pedido_minimo == null) {
      usuario.pedido_minimo = 0;
    }
    this.loginError = false;
    this.storageService.setItem('recordar', String(recordar));
    this.storageService.setItem('usuario', usuario.usuario);
    this.storageService.setItem('usuario_model', JSON.stringify(this.authService.usuario, jsonMapReplacer));
    this.storageService.setItem('usuarios_model', JSON.stringify(this.authService.usuarios, jsonMapReplacer));
    this.storageService.setItem('alm_id', this.authService.usuario.alm_id.toString());

    this.pedidoService.inicializaParametrosUsu();
    const isPaymentResult = typeof window !== 'undefined' && window.location.href.includes('/payment-result');
    if (this.router.url !== '/tienda' && !isPaymentResult) {
      this.router.navigate(['tienda']).then();
    }
  }
  public parametrosMap(): Map<string, any> {
    const parametrosM = new Map();
    // parametros x defecto: sacar de environment
    if (this.usuario != undefined) {
      this.usuario.parametros =
        'impuestos=false,imp_pedido_minimo=0,imp_pedido_maximo=0,ped_min_portes=0,imp_portes=0,dias_servicio=0,impuestos=N'
        + ',portes=' + (environment.PORTES ? 'S' : 'N')
        + ',ver_fec_servicio=' + (environment.FSERVICIO ? 'S' : 'N')
        + ',stock=' + environment.COMPRAR_SIN_STOCK
        + ',precio_caja=' + (environment.VER_PVP_CAJA ? 'S' : 'N')
        + ',tbulto_ver=' + (environment.TIPO_BULTO.replace(',', ';'))
        + ',tbulto_def=' + (environment.TIPO_BULTO_DEF);

      this.usuario.parametros.split(',').forEach((valor) => {
        const parametro = valor.split('=');
        parametrosM.set(parametro[0], parametro[1]);
      });
    }
    return parametrosM;
  }
  public logout() {
    this.storageService.removeItem('ACCESS_TOKEN');
    this.storageService.removeItem('ACCESS_TOKEN_DATE');
    this.storageService.removeItem('ACCESS_TOKEN_EXPIRE');
    this.storageService.removeItem('ACCESS_TOKEN_TYPE');
    this.storageService.removeItem('REFRESH_TOKEN');
    this.storageService.removeItem('REFRESH_TOKEN_EXPIRE');
    this.storageService.removeItem('usuario_model');
    this.storageService.removeItem('usuarios_model');
    this.storageService.removeItem('alm_id');
    this.articuloService.articulos = [];
    this.authService.usuario = undefined;
    this.loginCambioClave = false;
    this.loginCambiarClave = false;
    this.logoutSession(environment.CLIENT_SECRET, environment.CLIENT_ID, this.storageService.getItem('REFRESH_TOKEN')!);

  }

  public CambiaUsuario(userInd: number, users: Usuario[]): Usuario | undefined {
    let nuevoUsuario: Usuario | null;
    if (userInd != null) {
      nuevoUsuario = this.selectUsuarioList(users, userInd);
    }
    else {
      nuevoUsuario = this.selectUsuarioList(users, 0);
    }
    if (nuevoUsuario != null && this.authService.usuario != null && nuevoUsuario.cli_id !== this.authService.usuario.cli_id) {
      this.usuario = nuevoUsuario;
      this.authService.usuario = this.usuario;
      this.storageService.setItem('usuario', this.usuario.usuario);
      this.storageService.setItem('usuario_model', JSON.stringify(this.authService.usuario, jsonMapReplacer));
      this.storageService.setItem('alm_id', this.authService.usuario.alm_id != null ? this.authService.usuario.alm_id.toString() : '');
      if (this.pedidoService !== undefined) {
        this.pedidoService.inicializaParametrosUsu(true);
      }
    }
    let recordar = this.storageService.getItem("recordar") == 'true' ? true : false;
    this.procesaUsuarioObservable(this.usuario!, recordar);
    return this.usuario;
  }

  // usar pedidoService.inicializaParametrosUsu()
  private inicializaParametrosUsu() {
    const pedccId = (this.authService.usuario != null && this.authService.usuario.pedcc_id == null) ? '' : this.authService.usuario!.pedcc_id.toString();
    const listaId = (this.authService.usuario != null && this.authService.usuario.pedcc_lista_id == null) ? '' : this.authService.usuario!.pedcc_lista_id.toString();
    if (this.authService.usuario != undefined) {
      this.articuloService.parametros.alm_id = this.authService.usuario.alm_id.toString();
      this.articuloService.parametros.cli_id = this.authService.usuario.cli_id.toString();
      this.articuloService.parametros.pedcc_id = pedccId;
      this.articuloService.parametros.pedcc_lista_id = listaId;

      this.pedidoService.paramPedido.pedcc_id = pedccId;
      this.pedidoService.paramPedido.cli_id = this.authService.usuario.cli_id.toString();

      this.pedidoService.paramLista.pedcc_id = listaId;
      this.pedidoService.paramLista.cli_id = this.authService.usuario.cli_id.toString();
    }
  }

  public parametro(parametro: string) {
    const url = this.SERVER_ADM_URL + '/parametro';
    return this.http.post(url,
      {
        alm_id: (this.authService.usuario === undefined) ? '' : this.authService.usuario.alm_id.toString(),
        parametro
      }, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //Authorization: environment.AUTH_TOKEN ? 'Bearer ' + this.storageService.getItem('ACCESS_TOKEN') : this.SERVER_AUTH
        // //Authorization: this.SERVER_AUTH
      })
    });
  }
  getTokenApp(ci: string, clave: string, usuario: string): Observable<string[]> {
    const url = environment.OAUTH_URL_GMAUTH_ADMIN;
    const tokenCompleto: string[] = Array(6).fill('');
    let headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded');

    const body = new HttpParams()
      .set('client_id', ci)
      .set('grant_type', 'password')
      .set('password', clave)
      .set('username', usuario);

    return this.http.post<UsuarioAuth>(url, body.toString(), { headers }).pipe(
      map((res) => {
        tokenCompleto[0] = res.access_token;
        tokenCompleto[1] = res.expires_in.toString();
        tokenCompleto[2] = res.refresh_token;
        tokenCompleto[3] = res.refresh_expires_in.toString();
        tokenCompleto[4] = res.token_type;
        tokenCompleto[5] = Date.now().toString(); // Fecha de obtención
        return tokenCompleto;
      }),
      catchError(err => {
        console.error('Error al obtener el token:', err);
        return throwError(() => err);
      })
    );
  }

  logoutSession(cs: string, ci: string, refreshToken: string) {
    const url = environment.OAUTH_URL_GMAUTH + '/logout';

    let headers = new HttpHeaders().append('Content-Type', 'application/x-www-form-urlencoded');

    const body = new HttpParams()
      .set('refresh_token', refreshToken)
      .set('client_id', ci)
      .set('client_secret', cs);

    this.http.post(url, body.toString(), { headers }).subscribe();
  }

  public compruebaHash(hash: string) {
    const url = this.SERVER_ADM_URL + '/users/getUserByHash/' + hash;
    return this.http.get(url, { responseType: 'text' }); // Devolver el Observable
  }
  public async enviaCorreoCambioClave(username: string): Promise<void> {
    const url = `${this.SERVER_ADM_URL}/keycloak/users/update/password/email/url`;

    try {
      const tokenCompleto = await firstValueFrom(
        this.getTokenApp(
          environment.ADMIN_ID,
          environment.PASSWORD_ADMIN,
          environment.USERNAME_ADMIN
        )
      );

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        //Authorization: `Bearer ${tokenCompleto[0]}`
      });

      const params = new HttpParams()
        .set('userName', username)
        .set('realmName', environment.ADMIN_REALM);

      const response = await firstValueFrom(this.http.get(url, {
        headers,
        params,
        responseType: 'text'
      }));

      console.log('Respuesta:', response);
      alert('Si el usuario es válido, se enviará un correo. Revisa tu bandeja de entrada.');

    } catch (error: any) {
      console.error('Error al hacer la solicitud:', error);
      if (error?.error) console.error('Detalles del error:', error.error);
      console.error('Estado del error:', error.status);
      console.error('Mensaje de error:', error.message);
    }
  }






  public async cambiaClaveNueva(username: string, nuevaClave: string): Promise<void> {
    const url = `${this.SERVER_ADM_URL}/keycloak/users/update/password`;

    try {
      const tokenCompleto = await firstValueFrom(
        this.getTokenApp(
          environment.ADMIN_ID,
          environment.PASSWORD_ADMIN,
          environment.USERNAME_ADMIN
        )
      );

      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        //Authorization: `Bearer ${tokenCompleto[0]}`
      });

      const params = new HttpParams()
        .set('userName', username)
        .set('clave', nuevaClave)
        .set('realmName', environment.ADMIN_REALM);

      const response = await firstValueFrom(this.http.get(url, {
        headers,
        params,
        responseType: 'text'
      }));

      console.log('Respuesta:', response);

      this.login('', username, nuevaClave, false);
      if (this.router.url !== '') {
        await this.router.navigate(['']);
      }

    } catch (error: any) {
      console.error('Error al cambiar la clave:', this.authService.messageCambioClave);
      this.authService.messageCambioClave = error.error;
      // if (error?.error) console.error('Detalles del error:', error.error);
      // console.error('Estado del error:', error.status);
      // console.error('Mensaje de error:', error.message);
    }
  }

  public getRisk(customerCode: string): Observable<any> {
    const url = `${this.SERVER_HUB_URL}/customers/${customerCode}/risk`;
    return this.http.get<any>(url).pipe(
      catchError(() => of(0))
    );
  }

  validaTokenTurnstile(token: string) {
    const url = this.SERVER_URL + "/turnstile/verify";
    return this.http
      .post<{ ok: boolean }>(url, { token })
      .pipe(
        map(res => !!res?.ok),
        catchError(() => of(false))
      );
  }

}
